export default "__VITE_ASSET__DpeHEsj7__"